"use strict";Object.defineProperty(exports, "__esModule", {value: true});



var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/role/role.tsx
var TagName = "div";
var elements = [
  "a",
  "button",
  "details",
  "dialog",
  "div",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "section",
  "select",
  "span",
  "summary",
  "textarea",
  "ul",
  "svg"
];
var useRole = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useRole2(props) {
    return props;
  }
);
var Role = _PTOCUU2Dcjs.forwardRef.call(void 0, function Role2(props) {
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, props);
});
Object.assign(
  Role,
  elements.reduce((acc, element) => {
    acc[element] = _PTOCUU2Dcjs.forwardRef.call(void 0, function Role3(props) {
      return _PTOCUU2Dcjs.createElement.call(void 0, element, props);
    });
    return acc;
  }, {})
);




exports.useRole = useRole; exports.Role = Role;
